import { Check, Copy } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';
import { cn } from '@/lib/utils';
import { Button } from './ui/button';

interface CopyButtonProps {
  value: string;
  label?: string;
  /**
   * 'sm' (default): ícone compacto h-7, comportamento original.
   * 'lg': alvo grande h-14 ~140px com rótulo textual "Copiar" — Modo Compra
   * (Fitts: operador alterna Alt+Tab com a PSN, alvo grande na mesma coordenada).
   */
  size?: 'sm' | 'lg';
  /** Toast curto ("Email copiado") sem o sufixo de limpar a área de transferência. */
  plainToast?: boolean;
  className?: string;
}

export function CopyButton({ value, label, size = 'sm', plainToast, className }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      toast.success(
        plainToast
          ? `${label ?? 'Valor'} copiado`
          : `${label ?? 'Valor'} copiado — limpe a área de transferência depois.`,
      );
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Falha ao copiar');
    }
  };

  if (size === 'lg') {
    return (
      <Button
        type="button"
        variant="secondary"
        className={cn('h-14 w-[140px] shrink-0 text-base [&_svg]:size-5', className)}
        onClick={onCopy}
      >
        {copied ? <Check className="text-emerald-400" /> : <Copy />}
        {copied ? 'Copiado' : 'Copiar'}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn('h-7 w-7', className)}
      onClick={onCopy}
    >
      {copied ? <Check className="h-3.5 w-3.5 text-emerald-400" /> : <Copy className="h-3.5 w-3.5" />}
    </Button>
  );
}
